import { connect } from "react-redux";
import CreateVirtualSuiteMain from "./create_virtual_suite_main";
import React from "react";
import { withRouter } from "react-router-dom"
import { fetchServices, fetchContractors } from "../../actions/service_actions";
import { submitOrder } from "../../actions/project_actions";
import { openModal } from "../../actions/modal_actions";
import { fetchCurrentUser } from "../../actions/session_actions";
import { showToast } from "../../actions/toast_actions";
import { createVirtualStagingPurchase } from "../../actions/virtual_staging_actions";

const msp = (state, ownProps) => ({
  errors: Array.isArray(state.errors?.session) ? state.errors?.session : [],
  currentUser: state.session.currentUser ? state.entities.users[state.session.currentUser.id] : null,
  services: state.entities.services,
  contractors: state.entities.contractors,
});

const mdp = (dispatch) => ({
  fetchServices: () => dispatch(fetchServices()),
  fetchCurrentUser: (user_id) => dispatch(fetchCurrentUser(user_id)),
  createVirtualStagingPurchase: (orders) => dispatch(createVirtualStagingPurchase(orders)),
  submitOrder: (data) => dispatch(submitOrder(data)),
  openModal: (modal, props) => { dispatch(openModal(modal, props)); },
  showToast: (message) => dispatch(showToast(message)),
});

export default withRouter(connect(msp, mdp)(CreateVirtualSuiteMain));